import { createSlice } from '@reduxjs/toolkit'
import { Common, Messages } from '@/config/NextImport'

/* ---------- helpers ---------- */
const getCookie = (name: string) => {
  if (typeof document === 'undefined') return null
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift()
  return null
}

const applyPriceFromCookie = (products: any[]) => {
  const priceColumn = getCookie('priceColumn') // ex: CA_price
  if (!priceColumn) return products

  const countryCode = priceColumn.split('_')[0]

  const currencyData =
    JSON.parse(Common.decryptData(localStorage.getItem('currency') || '[]')) || []

  const currency = currencyData.find((c: any) => c.Code === countryCode)

  return products.map((item) => {
    const price = item[priceColumn]
    const filterPrice = item[`${countryCode}_filter_price`]

    return {
      ...item,
      price,
      filter_price: filterPrice,
      formated_price: `${currency?.currency_symbol}${price}`
    }
  })
}

/* ---------- slice ---------- */

const initialState: any = {
  compareProducts: []
}

const compareProductsSlice = createSlice({
  name: 'compareProducts',
  initialState,
  reducers: {
    setCompareProducts: (state, action) => {
      state.compareProducts = applyPriceFromCookie(action.payload)
    },

    addToCompare: (state, action) => {
      const compareData =
        JSON.parse(Common.decryptData(localStorage.getItem(Messages.CompareProducts) || '[]')) || []

      const exists = compareData.some((item: any) => item.sku === action.payload.sku)

      let updatedData = compareData

      if (exists) {
        updatedData = compareData.filter((item: any) => item.sku !== action.payload.sku)
      } else {
        updatedData = [...compareData, action.payload]
      }

      updatedData = applyPriceFromCookie(updatedData)

      state.compareProducts = updatedData

      localStorage.setItem(
        Messages.CompareProducts,
        Common.encryptData(JSON.stringify(updatedData))
      )
    },

    /** 🔥 CALL ON COUNTRY CHANGE */
    updateComparePriceFromCookie: (state) => {
      const updatedData = applyPriceFromCookie(state.compareProducts)

      state.compareProducts = updatedData

      localStorage.setItem(
        Messages.CompareProducts,
        Common.encryptData(JSON.stringify(updatedData))
      )
    }
  }
})

export const { addToCompare, setCompareProducts, updateComparePriceFromCookie } =
  compareProductsSlice.actions

export default compareProductsSlice.reducer
